import React, {Component} from 'react';
import { Col, Row, Button, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import config from  '../../../config';
import Select   from 'react-select'
import {
    ADD_SELECTED_USERS, CLEAR_SELECTED_USERS} from "actions/actionTypes";
export default class AdminUsersSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
             filterOptions: {
                 searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                  fromCreateTimeDisplay: _.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from),
                  toCreateTimeDisplay: _.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to),
                 perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,

            }
        };
        this.onCreateTimeChange = this.onCreateTimeChange.bind(this);
    };


    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }
    onCreateTimeChange(option, createTimeOptionName) {
        var isSameDate =  moment(this.state.filterOptions[createTimeOptionName]).isSame(option, 'day')
         var updateOptions = {...this.state.filterOptions,  [createTimeOptionName]: option};
        this.setState({'filterOptions': updateOptions}, function () {
            if (!isSameDate) {
                this.props.search();
            }
        });
    }
    getSearchParams(filtersChanged = {} ) {
         var filterOptions = {...this.state.filterOptions, ...filtersChanged};

      var  queryParams = {};

        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if (filterOptions.fromCreateTimeDisplay !== '') {
            queryParams.from = filterOptions.fromCreateTimeDisplay.toISOString()
        }
        if (filterOptions.toCreateTimeDisplay !== '') {
            queryParams.to = filterOptions.toCreateTimeDisplay.toISOString()
        }
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
       return queryParams
    }
    onSelectAllRecordsChange() {
        var self = this;
        if (!this.props.selectAllRecords) {

            this.props.search( {include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)


                self.props.dispatchAction(response.data.data, ADD_SELECTED_USERS)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_USERS)
        }
    }
    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }
    onsearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    render() {
        var self = this;
console.log('this.state', this.state  );

         return (
            <div className="seller-search-block bot15">
                <Row className="">
                    <Col md={3} xs={3} className="top10">
                        <Button className="btn btn-primary" onClick = {this.onSelectAllRecordsChange.bind(this)} >
                            {this.props.selectAllRecords ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                    <Col md={3} xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>
                <Row className="show-grid">
                    <Col md={3} xs={3} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                      onChange={this.onsearchTextChange.bind(this)}
                                     placeholder="Search text"/>
                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Col xs={6} className="pleft0">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                      onChange={(value) =>this.onCreateTimeChange(value,  'fromCreateTimeDisplay')}
                                      value={this.state.filterOptions.fromCreateTimeDisplay}
                                      inputProps={{placeholder: 'From'}}/>
                        </Col>
                        <Col xs={6} className="pleft0 pright0">
                            <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                      onChange={(value) =>this.onCreateTimeChange(value,  'toCreateTimeDisplay')}
                                      value={this.state.filterOptions.toCreateTimeDisplay}
                                      inputProps={{placeholder: 'To'}}/>
                        </Col>
                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending} onClick={(event) => self.props.search({ })}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>
            </div>
        );
    }
}



